import axios from '@plugins/axios';

class TicketService {
    getList(params = {}, options = {}) {
        return axios({
            url: `sistema/ticket`,
            method: 'GET',
            params,
            ...options
        });
    }
    get(id, options = {}) {
        return axios({
            url: `sistema/ticket/${id}`,
            method: 'GET',
            ...options
        });
    }
}

export const BaseTicketService = TicketService;

export default new TicketService();